export default [
    {
        path: '/affiliates',
        name: 'Affiliates',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Affiliates',
        },
        components: {
            default: () => import('@views/affiliates/AffiliatesIndex.vue'),
        },
    },
    {
        path: '/affiliates/create',
        name: 'AffiliatesCreate',
        props: {
            default: () => ({ isCreate: true }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create affiliate',
        },
        components: {
            default: () => import('@views/affiliates/AffiliatesForm.vue'),
        },
    },
    {
        path: '/affiliates/:id/edit',
        name: 'AffiliatesEdit',
        props: {
            default: (route) => ({ id: route.params.id, isCreate: false }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Edit affiliate',
        },
        components: {
            default: () => import('@views/affiliates/AffiliatesForm.vue'),
        },
    },
    {
        path: '/affiliates/leads/:id?/view',
        name: 'AffiliatesLeads',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Affiliate leads',
        },
        components: {
            default: () => import('@views/affiliates/AffiliatesLeads.vue'),
        },
    },
];
